import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";

const createAddress = credentials => {
    let url = apiUrlWithLang('/dashboard/api/address/update')
    return axios.post(url, credentials)
}

const updateAddress = credentials => {
    let url = apiUrlWithLang('/dashboard/api/address/update')
    return axios.post(url, credentials)
}

const getAddress = credentials => {
    let url = apiUrlWithLang('/dashboard/api/address?_order_by=created')
    return axios.get(url, { params:credentials })
}

const removeAddress = credentials => {
    let url = apiUrlWithLang('/dashboard/api/address/delete')
    return axios.delete(url, {data: credentials})
}
export default {
    getAddress,
    removeAddress,
    createAddress,
    updateAddress
}